const p = Object.getPrototypeOf({});
const isChangeEventHandler = (
// eslint-disable-next-line @typescript-eslint/no-unused-vars
event, handler) => {
    return event === '@changed';
};
const isPromise = (x) => {
    return typeof x.then === 'function';
};
const isObject = (x) => {
    return x && Object.getPrototypeOf(x) === p;
};
const isSymbol = (x) => {
    return x && typeof x === 'symbol';
};
const diff = (oldState = {}, newState = {}) => {
    return [...Object.keys(oldState), ...Object.keys(newState)].reduce((r, key) => {
        if (oldState[key] !== newState[key]) {
            r[key] = newState[key];
        }
        return r;
    }, {});
};
/**
 * Creates instance of storeon feature sub store.
 *
 * @example
 * import createStore from "storeon";
 * import { substore } from "storeon-substore";
 * // create store
 * const store = createStore([(store) => {
 *    store('@init', () => ({
 *        feature: {
 *            flag: true,
 *        },
 *    }));
 * }]);
 * const featureStore = createSubstore(store, 'feature');
 * featureStore.on('toggleFeatureBooleanFlag', (state) => ({
 *   flag: state ? !state.flag : true,
 * }));
 * featureStore.dispatch('toggleFeatureBooleanFlag');
 * featureStore.get(); // returns { flag: false }
 *
 */
export function createSubstore(store, key, scopeEvents) {
    const k = key;
    const scopeEventsMap = {
        '@init': '@init',
        '@changed': '@changed',
        '@dispatch': '@dispatch'
    };
    const getEvent = (event) => {
        if (!scopeEvents) {
            return event;
        }
        if (!scopeEventsMap[event]) {
            scopeEventsMap[event] = isSymbol(event)
                ? Symbol(`[@${key}] ${event.description || event.toString()}`)
                : scopeEventsMap[event] = `[@${key}] ${event} `;
        }
        return scopeEventsMap[event];
    };
    const get = () => {
        const s = store.get();
        return s ? s[key] : undefined;
    };
    const newStore = {
        on: (event, handler) => {
            if (isChangeEventHandler(event, handler)) {
                let localState = get();
                const unregister = store.on('@changed', (state) => {
                    const newState = state ? state[key] : undefined;
                    if (localState !== newState) {
                        const changes = isObject(newState) ? diff(localState, newState) : {};
                        localState = newState;
                        handler(newState, changes, newStore);
                    }
                });
                return () => {
                    localState = undefined;
                    unregister();
                };
            }
            return store.on(getEvent(event), (state, data) => {
                const r = handler(state ? state[key] : undefined, data, newStore);
                if (typeof r !== 'undefined' && r !== null) {
                    if (isPromise(r))
                        return r;
                    if (!state || r !== state[k]) {
                        return ({
                            [key]: isObject(r)
                                ? Object.assign(Object.assign({}, (state ? state[k] : undefined)), r) : r,
                        });
                    }
                }
            });
        },
        get,
        dispatch: ((event, ...data) => {
            store.dispatch(getEvent(event), ...(data || []));
        })
    };
    return newStore;
}
//# sourceMappingURL=index.js.map